import { Container } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { theme } from '../style';
import Footer from './Footer';
import Header from './Header';
import Stepper from './Stepper';
import Action from './action/Index';

interface ILayoutProps {}

const Layout = (props: ILayoutProps) => (
    <React.Fragment>
        <CssBaseline />
        <ThemeProvider theme={theme}>
            <Container variant='body' maxWidth={false}>
                <Header />
                <Action />
                <Stepper />
                <Outlet />
                <Footer />
            </Container>
        </ThemeProvider>
    </React.Fragment>
);

export default Layout;
